var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8323 10.824L19.6199 3.06947C20.1267 2.56507 20.1267 1.74952 19.6199 1.24512C19.1133 0.740721 18.2943 0.740721 17.7877 1.24512L9.99989 8.99968L2.21228 1.24512C1.70548 0.740721 0.88667 0.740721 0.380103 1.24512C-0.126701 1.74952 -0.126701 2.56507 0.380103 3.06947L8.16771 10.824L0.380103 18.5786C-0.126701 19.083 -0.126701 19.8985 0.380103 20.4029C0.632556 20.6546 0.964494 20.781 1.29619 20.781C1.62789 20.781 1.95959 20.6546 2.21228 20.4029L9.99989 12.6484L17.7877 20.4029C18.0404 20.6546 18.3721 20.781 18.7038 20.781C19.0355 20.781 19.3672 20.6546 19.6199 20.4029C20.1267 19.8985 20.1267 19.083 19.6199 18.5786L11.8323 10.824Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGray);
export default __webpack_public_path__ + "static/media/close-icon-gray.359a53d009232590c33ed0e8525ff371.svg";
export { ForwardRef as ReactComponent };